import { render } from "./BlogDetail.vue?vue&type=template&id=3c082346&scoped=true"
import script from "./BlogDetail.vue?vue&type=script&lang=js"
export * from "./BlogDetail.vue?vue&type=script&lang=js"

import "./BlogDetail.vue?vue&type=style&index=0&id=3c082346&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c082346"]])

export default __exports__